import React from 'react'

function CheckoutPromoGiftCard(props) {
  //console.error("NOT IMPLEMENTED: CheckoutGiftCard");
  return (<div className="giftCard"></div>);
}

export default CheckoutPromoGiftCard


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/CheckoutPromoGiftCard.jsx